/** Type d'absence d'un collaborateur. */
// « vacances » est l'identifiant historique du congé payé (stocké en base, dans les feuilles d'heures
// __abs_vacances__ et le trigger du solde CP) : seul le libellé a changé.
export type AbsenceType =
  'vacances' | 'maladie' | 'cours' | 'temps_partiel' | 'conge_exceptionnel' | 'sans_solde';
export const ABSENCE_TYPES: { id: AbsenceType; label: string; color: string }[] = [
  { id: 'vacances', label: 'Congé payé', color: '#378ADD' },
  { id: 'maladie', label: 'Maladie', color: '#D85A30' },
  { id: 'cours', label: 'Cours', color: '#639922' },
  { id: 'temps_partiel', label: 'Temps partiel', color: '#EF9F27' },
  { id: 'conge_exceptionnel', label: 'Congé exceptionnel', color: '#D4537E' },
  { id: 'sans_solde', label: 'Sans solde', color: '#7F77DD' },
];
// Cours et temps partiel sont les seuls types qui ne demandent jamais de validation — s'acceptent
// automatiquement quel que soit qui les saisit (cf. saveAbsence). Tout le reste (congé payé, maladie,
// congé exceptionnel, sans solde) nécessite une décision humaine.
export const NO_VALIDATION_TYPES: readonly string[] = ['cours', 'temps_partiel'];
export const LEAVE_TYPES = ABSENCE_TYPES.map((t) => t.id).filter(
  (id) => !NO_VALIDATION_TYPES.includes(id),
);
// Seul type retiré du solde de congés payés : le congé payé, à l'acceptation (trigger
// user_absences_sync_leave_balance, migration 020). Maladie, congé exceptionnel (mariage,
// naissance, décès) et sans solde demandent une validation mais ne consomment pas de CP.
export const PAID_LEAVE_TYPES: readonly string[] = ['vacances'];
// Statuts d'une demande d'absence : couleurs et libellé associés. Remplace un tableau de trois
// valeurs positionnelles ([fond, couleur, libellé]) dont l'ordre devait être deviné à la lecture.
/** Statut d'une demande d'absence. */
export type AbsenceStatus = 'acceptee' | 'refusee' | 'attente';
export interface StatusStyle {
  fond: string;
  couleur: string;
  libelle: string;
}
export const ABSENCE_STATUSES: Readonly<Record<AbsenceStatus, StatusStyle>> = Object.freeze({
  acceptee: { fond: '#E3F5EC', couleur: '#1D9E75', libelle: 'Acceptée' },
  refusee: { fond: '#FBEAEA', couleur: '#E24B4A', libelle: 'Refusée' },
  attente: { fond: '#FFFBF3', couleur: '#B4870F', libelle: 'En attente' },
});
export const DEFAULT_ABSENCE_STATUS = ABSENCE_STATUSES.attente;
